const toTitleCase = (str) => {
    if (!str || !isNaN(str)) return str;
    return str
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

export default toTitleCase;
